.card {
  display: flex;
  flex-direction: column;
  gap: 4px;
  padding: 4px 8px;
  text-decoration: none;
  cursor: pointer;
  width: 100%;
  border-radius: 8px;

  &:hover {
    background: var(--dark-2);
  }
}

.cardStatic {
  cursor: default;

  &:hover {
    background: transparent;
  }
}

.content {
  display: flex;
  flex-direction: column;
  gap: 6px;

  > span:first-child {
    line-height: 140%;
  }
}

.header {
  display: flex;
  align-items: center;
  gap: 12px;
  justify-content: space-between;
  width: 100%;
}
